import { makeStyles } from "@material-ui/core";
import { FC, memo } from "react";
import { SaveButton, Toolbar, ToolbarProps, useFormGroup } from "react-admin";

import { GenericObject } from "../types/generic.types";
import { areEqual } from "../utils/generic";
import ErrorListing from "./ErrorListing";

const useStyles = makeStyles((theme) => ({
  toolbar: {
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: theme.spacing(2, 0),
    backgroundColor: "transparent",
  },
}));

const CustomToolbar: FC<CustomToolbarProps> = (props) => {
  const { invalid, formName, customErrors = {} } = props;
  const classes = useStyles(props);
  const state = useFormGroup(formName);

  const isDisabled = invalid || Object.values(customErrors).some((error) => !!error);

  return (
    <Toolbar {...props} className={classes.toolbar} style={{ position: "relative" }}>
      <SaveButton disabled={isDisabled} />

      {state.errors ? <ErrorListing errors={{ ...state.errors, ...customErrors }} /> : null}
    </Toolbar>
  );
};

interface CustomToolbarProps extends ToolbarProps {
  formName: string;
  customErrors?: GenericObject;
}

export default memo(CustomToolbar, areEqual);
